import { connect } from 'react-redux';
import { compose, withProps, flattenProp } from 'recompose';
import { withFirestore } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  headerCell: {
    fontWeight: 'bold'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default compose(
  // Map redux state to props
  connect(
    mapStateToProps,
    null
  ),
  withRouter,
  withFirestore,
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  // Flatten profile so that avatarUrl and displayName are props
  flattenProp('profile'),
  // Add styles as classes prop
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/shared/DealsOverviewTable.enhancer.js